import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { User } from '../../interfaces';

@Injectable({
    providedIn: 'root'
})
export class PushNotificationsService {
    private path = environment.apiUrl;
    constructor(private http: HttpClient) {}

    registerDeviceOnServer(token: string) {
        return this.http.post<User>(`${this.path}/push-notifications/register`, { deviceId: token });
    }
    subscribeUserToTopic() {
        return this.http.post<User>(`${this.path}/push-notifications/subscribe`, {});
    }
    unsubscribeUserFromTopic() {
        return this.http.post<User>(`${this.path}/push-notifications/unsubscribe`, {});
    }
}
